import { createRoute } from '@tanstack/react-router';

import { AdminBaseRouteLayout } from '$/routes/Admin/AdminBaseRouteLayout';

export const AdminContactRoute = createRoute({
  getParentRoute: () => AdminBaseRouteLayout,
  path: '/admin/contact',
}).lazy(() => import('./AdminContactRoute.lazy').then((d) => d.Route));
